module.exports = __webpack_public_path__ + "static/media/email.eefddf24.svg";